/* MY TOP SHOP — Réparation : sélecteur appareil → panne, pré-remplissage du devis, liens profonds (?appareil=&panne=) */
(function () {
  var d = document;
  var mq = window.matchMedia('(max-width: 989px)');

  function init(root) {
    (root || d).querySelectorAll('[data-mt-finder]').forEach(function (f) {
      if (f.dataset.mtReady) return;
      f.dataset.mtReady = '1';

      var tabs = Array.prototype.slice.call(f.querySelectorAll('[data-dev]'));
      var panels = f.querySelectorAll('[data-panel]');
      var card = f.querySelector('[data-mt-card]');
      var selDev = f.querySelector('[data-f-dev]');
      var selPan = f.querySelector('[data-f-pan]');
      var model = f.querySelector('[data-f-model]');

      function filterPannes(slug) {
        if (!selPan) return;
        selPan.querySelectorAll('option[data-for]').forEach(function (o) {
          var list = ' ' + o.dataset.for + ' ';
          var ok = slug === 'autre' || o.dataset.for === '*' || list.indexOf(' ' + slug + ' ') > -1;
          o.hidden = !ok;
          o.disabled = !ok;
        });
        var cur = selPan.options[selPan.selectedIndex];
        if (cur && cur.disabled && cur.value) selPan.value = '';
      }

      function setDev(slug, opts) {
        opts = opts || {};
        var tab = null;
        tabs.forEach(function (t) {
          var on = t.dataset.dev === slug;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on) tab = t;
        });
        panels.forEach(function (p) {
          var on = p.dataset.panel === slug;
          if (on && p.hidden) { p.hidden = false; p.classList.remove('is-shown'); void p.offsetWidth; p.classList.add('is-shown'); }
          else if (!on) { p.hidden = true; p.classList.remove('is-shown'); }
          if (!on) p.querySelectorAll('[aria-pressed="true"]').forEach(function (r) { r.setAttribute('aria-pressed', 'false'); });
        });
        if (tab && opts.focus) tab.focus();
        if (tab && opts.scroll) tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        if (selDev && !opts.fromSelect) {
          for (var i = 0; i < selDev.options.length; i++) {
            if (selDev.options[i].dataset.slug === slug) { selDev.selectedIndex = i; break; }
          }
        }
        if (model) model.placeholder = (tab && tab.dataset.ph) || model.dataset.ph || '';
        filterPannes(slug);
      }

      function currentSlug() {
        var t = tabs.filter(function (x) { return x.getAttribute('aria-selected') === 'true'; })[0];
        return t ? t.dataset.dev : '';
      }

      function pickPanne(row, opts) {
        opts = opts || {};
        var panel = row.closest('[data-panel]');
        if (panel) panel.querySelectorAll('.mt-pan__row').forEach(function (r) { r.setAttribute('aria-pressed', r === row ? 'true' : 'false'); });
        if (selPan) {
          var val = row.dataset.panne;
          for (var i = 0; i < selPan.options.length; i++) {
            var o = selPan.options[i];
            if (o.value === val && !o.disabled) { selPan.selectedIndex = i; break; }
          }
        }
        if (card) { card.classList.remove('is-ping'); void card.offsetWidth; card.classList.add('is-ping'); }
        if (opts.silent) return;
        if (mq.matches) {
          card.scrollIntoView({ behavior: 'smooth', block: 'start' });
          setTimeout(function () { if (model && !model.value) model.focus({ preventScroll: true }); }, 600);
        } else if (model && !model.value) {
          model.focus({ preventScroll: true });
        }
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { setDev(t.dataset.dev); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, j = -1;
          if (k === 'ArrowRight' || k === 'ArrowDown') j = (i + 1) % tabs.length;
          else if (k === 'ArrowLeft' || k === 'ArrowUp') j = (i - 1 + tabs.length) % tabs.length;
          else if (k === 'Home') j = 0;
          else if (k === 'End') j = tabs.length - 1;
          if (j > -1) { e.preventDefault(); setDev(tabs[j].dataset.dev, { focus: true, scroll: true }); }
        });
      });

      f.querySelectorAll('.mt-pan__row').forEach(function (row) {
        row.addEventListener('click', function () { pickPanne(row); });
      });

      if (selDev) selDev.addEventListener('change', function () {
        var o = selDev.options[selDev.selectedIndex];
        var slug = o && o.dataset.slug;
        if (slug && slug !== 'autre') setDev(slug, { fromSelect: true });
        else filterPannes('autre');
      });

      if (selPan) selPan.addEventListener('change', function () {
        var panel = f.querySelector('[data-panel="' + currentSlug() + '"]');
        if (!panel) return;
        panel.querySelectorAll('.mt-pan__row').forEach(function (r) {
          r.setAttribute('aria-pressed', r.dataset.panne === selPan.value ? 'true' : 'false');
        });
      });

      /* Liens profonds : ?appareil=ps5&panne=HDMI ou #ps5 */
      var q = new URLSearchParams(location.search);
      var want = (q.get('appareil') || location.hash.replace('#', '')).toLowerCase();
      var start = tabs.some(function (t) { return t.dataset.dev === want; }) ? want : currentSlug();
      setDev(start);
      var wantPan = q.get('panne');
      if (wantPan) {
        var panel = f.querySelector('[data-panel="' + start + '"]');
        var row = panel && Array.prototype.filter.call(panel.querySelectorAll('.mt-pan__row'), function (r) {
          return r.dataset.panne.toLowerCase() === wantPan.toLowerCase();
        })[0];
        if (row) pickPanne(row, { silent: true });
      }
      if (want && start === want) setTimeout(function () { f.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 300);
    });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();